var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{nativeOn:{"click":function($event){return _vm.login($event)}}},[_vm._v("АИС Адвокатура")])}
var staticRenderFns = []

export { render, staticRenderFns }